module.exports = __webpack_public_path__ + "media/images/pic/sample2-4af149f465a4b22f71a0c690256a48b0.webp";